import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { KULTOUR_ENABLED } from "../../config";

const ALL_NAV_LINKS = [
  { href: "#hero",     title: "Start" },
  { href: "#about",    title: "Orchester" },
  { href: "#players",  title: "Spielende" },
  { href: "#join",     title: "Mitspielen" },
  { href: "#concerts", title: "Konzerte" },
  { href: "#kultour",  title: "KulTOUR", flag: KULTOUR_ENABLED },
  { href: "#contact",  title: "Kontakt" },
];

const NAV_LINKS = ALL_NAV_LINKS.filter((l) => l.flag !== false);

function AppHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);

      // Active section tracking
      const sections = NAV_LINKS.map((l) => l.href.replace("#", ""));
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.getBoundingClientRect().top <= 110) {
          setActiveSection(sections[i]);
          return;
        }
      }
      setActiveSection("hero");
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeDrawer = () => setDrawerOpen(false);

  const scrollTo = (e, href) => {
    e.preventDefault();
    const id = href.replace("#", "");
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    closeDrawer();
  };

  return (
    <div
      className="headerWrapper"
      style={{
        background: scrolled ? "rgba(255,255,255,0.97)" : "var(--color-primary)",
        boxShadow: scrolled ? "0 2px 14px rgba(0,0,0,0.09)" : "none",
        transition: "background 0.4s ease, box-shadow 0.4s ease",
      }}
    >
      <div className="container-fluid headerInner">
        {/* Logo */}
        <a href="#hero" onClick={(e) => scrollTo(e, "#hero")} className="headerLogo">
          <div className="mobileHidden">
            <img
              src="/images/logo_saxemble_transparent.png"
              alt="sax'emble Logo"
              height={62}
              width={Math.round(62 * 2.76)}
            />
          </div>
          <div className="mobileVisible">
            <img
              src="/images/logo_saxemble_transparent.png"
              alt="sax'emble Logo"
              height={44}
              width={Math.round(44 * 2.76)}
            />
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="desktopNav mobileHidden">
          {NAV_LINKS.map((link) => {
            const id = link.href.replace("#", "");
            const isActive = activeSection === id;
            return (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollTo(e, link.href)}
                className={`navLink ${isActive ? "navLinkActive" : ""} ${scrolled ? "navLinkScrolled" : "navLinkYellow"}`}
              >
                {link.title}
              </a>
            );
          })}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="menuBtn mobileVisible"
          onClick={() => setDrawerOpen(!drawerOpen)}
          aria-label={drawerOpen ? "Menü schließen" : "Menü öffnen"}
          style={{ color: "#111" }}
        >
          {drawerOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      {/* Mobile Drawer */}
      {drawerOpen && (
        <div className="mobileVisible drawerOverlay" onClick={closeDrawer}>
          <div className="drawerPanel" onClick={(e) => e.stopPropagation()}>
            <div className="drawerHeader">
              <img
                src="/images/logo_saxemble_transparent.png"
                alt="sax'emble Logo"
                height={42}
                width={Math.round(42 * 2.76)}
              />
              <button className="drawerCloseBtn" onClick={closeDrawer} aria-label="Schließen">
                <FaTimes size={22} />
              </button>
            </div>
            <nav className="drawerNav">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="drawerLink"
                  onClick={(e) => scrollTo(e, link.href)}
                >
                  {link.title}
                </a>
              ))}
            </nav>
          </div>
        </div>
      )}
    </div>
  );
}

export default AppHeader;
